// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.

const CHANGELOG = [
    {
        version: 'dp1.2',
        date: '2026-08-09',
        title: 'Demo Rapichontico',
        notes: [
            { type: 'feature',     text: 'Balotera en el home: sorteo animado de 4 balotas que revela el combinado ganador' },
            { type: 'feature',     text: 'Sorteo cada 30 minutos con cuenta regresiva e historial de los últimos 10 resultados' },
            { type: 'feature',     text: 'Tienda de números 0000–9999 con búsqueda por prefijo, paginación, número sorpresa y carrito de hasta 20 números' },
            { type: 'feature',     text: 'Checkout simulado con validación de tarjeta y comprobante de compra' },
            { type: 'feature',     text: 'Página “Mis números” con estado de cada compra (en juego / acertado / no salió)' },
            { type: 'feature',     text: '5.500 números aparecen vendidos al abrir cada sesión; el resto quedan libres' },
            { type: 'improvement', text: 'Identidad visual Rapichontico: azul #013a89, amarillo #f7ee1c y tipografías Outfit + Inter' },
            { type: 'breaking',    text: 'Se retiró el scaffolding del template (feature de ejemplo, SimpleCrud, login) — el demo no tiene backend ni autenticación' },
        ],
    },
    {
        version: 'dp1.1',
        date: '2026-05-16',
        title: 'Example feature + SimpleCrud',
        notes: [
            { type: 'feature',     text: 'Nueva feature de ejemplo en /admin/example con CRUD completo (lista filtrada, crear, editar, eliminar)' },
            { type: 'feature',     text: 'Componente genérico SimpleCrud en common/components/ — listo para catálogos de tipo {id, name, description}' },
            { type: 'feature',     text: 'Página /admin/example/categories que demuestra el uso de SimpleCrud' },
            { type: 'improvement', text: 'Set inicial de iconos SVG en common/icons/ (Edit, Trash, Plus, Eye, EyeOff)' },
        ],
    },
    {
        version: 'dp1.0',
        date: '2026-05-15',
        title: 'Plantilla inicial',
        notes: [
            { type: 'feature', text: 'Esqueleto inicial conformante a TSS vite v1' },
        ],
    },
];

export default CHANGELOG;
